<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>系统设置</el-breadcrumb-item>
			<el-breadcrumb-item>角色管理</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="btns">
			<el-button type="primary" size="small" @click="add">添加角色</el-button>
		</div>
		<el-table :data="list" border>
			<el-table-column prop="id" label="ID"></el-table-column>
			<el-table-column prop="name" label="角色"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
export default {
	data() {
		return {
			list: [],
			isLoad: false,
			pageSize: 20,
			page: 1,
			total: 0
		}
	},
	created() {
		this.loadList();
	},
	methods: {
		loadList() {
			this.isLoad = !this.isLoad
			this.axios.get('store/Role/index',{params:{
				page:this.page,
				pagesize: this.pageSize
			}}).then(res => {
				this.isLoad = !this.isLoad
				this.list = res.data.list.data
				this.total = res.data.list.total
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		sizeReload(val) {
			this.page = 1
			this.pageSize = val
			this.loadList()
		},
		pageReload(val) {
			this.page = val
			this.loadList()
		},
		edit(id) {
			this.$router.push({
				path: '/Role/edit.html',
				query: {
					id: id
				}
			});
		},
		add() {
			this.$router.push({
				path: '/Role/edit.html'
			});
		},
		del(id) {
			this.isLoad = !this.isLoad
			this.axios.delete('store/Role/delete', {data: {
				id
			}}).then(() => {
				this.isLoad = !this.isLoad
				this.$message.success({
					message: '删除成功',
				});
				this.loadList()
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		}
	}
}
</script>
<style scoped>
</style>
